import { styled } from '@mui/material/styles';
import { RoundedWrapper } from '@raisin/components-lib';

export const BankOffersListWrapper = styled(RoundedWrapper)(({ theme }) => ({
  marginBottom: theme.spacing(12),
}));
